import { render } from "./DynamicHtmlP.vue?vue&type=template&id=4b1809de&ts=true"
import script from "./DynamicHtmlP.vue?vue&type=script&lang=ts"
export * from "./DynamicHtmlP.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicHtmlP.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b1809de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b1809de', __exports__)) {
    api.reload('4b1809de', __exports__)
  }
  
  module.hot.accept("./DynamicHtmlP.vue?vue&type=template&id=4b1809de&ts=true", () => {
    api.rerender('4b1809de', render)
  })

}


export default __exports__